import { render, staticRenderFns } from "./SubscriptionCard.vue?vue&type=template&id=b8150a2a&scoped=true&"
import script from "./SubscriptionCard.vue?vue&type=script&lang=js&"
export * from "./SubscriptionCard.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionCard.vue?vue&type=style&index=0&id=b8150a2a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8150a2a",
  null
  
)

export default component.exports